export interface ForgotPasswordRequest {
    email: string;
}

export interface ForgotPasswordResponse {
    status: 'success' | 'error';
    details: {
        message: string;
        transactionId: string;
    };
}

export interface VerifyOTPRequest {
    email: string;
    otp: string;
    transactionId: string;
}

export interface VerifyOTPResponse {
    status: 'success' | 'error';
    details?: {
        message: string;
        oid?: string; // OID returned after successful OTP verification
    };
    error?: string;
}

export interface ResetPasswordRequest {
    transactionId: string;
    new_password: string;
    new_password_confirm: string;
}

export interface ResetPasswordResponse {
    status: 'success';
    message: string;
}

export interface SetForgotPasswordRequest {
    email: string;
    otp: string;
    transactionId: string;
    oid: string;
    password: string;
}

export interface SetForgotPasswordResponse {
    status: 'success' | 'error';
    details?: {
        message: string;
    };
    error?: string;
}

export interface ResetPasswordError {
    error?: string;
    code?: string;
    message?: string;
    errors?: Array<{
        field: string;
        message: string;
        code: string;
    }>;
}

export interface ForgotPasswordError {
    code: string;
    message: string;
    field?: string;
}